import React, { useState } from 'react';
import './SearchForm.css';

const SearchForm = ({ onSearch, loading }) => {
  const [searchType, setSearchType] = useState('name'); // 'name' or 'epic'
  const [formData, setFormData] = useState({
    firstName: '',
    middleName: '',
    surname: '',
    epic: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchType === 'name') {
      if (!formData.firstName && !formData.middleName && !formData.surname) {
        alert('कृपया किमान एक नाव प्रविष्ट करा (Please enter at least one name)');
        return;
      }
    } else {
      if (!formData.epic) {
        alert('कृपया EPIC ID प्रविष्ट करा (Please enter EPIC ID)');
        return;
      }
    }
    onSearch({ ...formData, searchType });
  };

  const handleReset = () => {
    setFormData({
      firstName: '',
      middleName: '',
      surname: '',
      epic: ''
    });
  };

  return (
    <div className="search-form-container">
      <div className="search-tabs">
        <button
          type="button"
          className={`tab-button ${searchType === 'name' ? 'active' : ''}`}
          onClick={() => setSearchType('name')}
        >
          नावाने शोधा
        </button>
        <button
          type="button"
          className={`tab-button ${searchType === 'epic' ? 'active' : ''}`}
          onClick={() => setSearchType('epic')}
        >
          EPIC ID द्वारे शोधा
        </button>
      </div>

      <form className="search-form" onSubmit={handleSubmit}>
        {searchType === 'name' ? (
          <>
            <div className="form-group">
              <label htmlFor="firstName">
                प्रथम नाव (इंग्रजी)
              </label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="Enter first name"
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="middleName">
                वडील / पती / पत्नी / इतर नाव (इंग्रजी)
              </label>
              <input
                type="text"
                id="middleName"
                name="middleName"
                value={formData.middleName}
                onChange={handleChange}
                placeholder="Enter middle name"
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="surname">
                आडनाव नाव (इंग्रजी)
              </label>
              <input
                type="text"
                id="surname"
                name="surname"
                value={formData.surname}
                onChange={handleChange}
                placeholder="Enter surname"
                className="form-input"
              />
            </div>
          </>
        ) : (
          <div className="form-group">
            <label htmlFor="epic">
              EPIC ID
            </label>
            <input
              type="text"
              id="epic"
              name="epic"
              value={formData.epic}
              onChange={handleChange}
              placeholder="Enter EPIC ID"
              className="form-input"
            />
          </div>
        )}

        <div className="form-actions">
          <button 
            type="submit" 
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? 'शोधत आहे...' : 'शोधा'}
          </button>
          <button 
            type="button" 
            className="btn btn-secondary"
            onClick={handleReset}
            disabled={loading}
          >
            क्लीअर
          </button>
        </div>
      </form>
    </div>
  );
};

export default SearchForm;
